import { Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface TabSectionProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  isProfileOwner?: boolean;
}

const TabSection = ({
  activeTab,
  setActiveTab,
  isProfileOwner = false,
}: TabSectionProps) => {
  const theme = useTheme();

  const allTabs = [
    { id: 'onboarding', label: 'Onboarding', ownerOnly: true },
    { id: 'profile', label: 'Profile', ownerOnly: false },
    { id: 'posts', label: 'Posts', ownerOnly: false },
    { id: 'replies', label: 'Replies', ownerOnly: false },
    // { id: 'aiReplies', label: 'AI Replies', ownerOnly: false },
  ];

  const tabs = allTabs.filter((tab) => !tab.ownerOnly || isProfileOwner);

  return (
    <Box sx={{ mt: 4 }}>
      <Box display='flex' flexDirection='row' justifyContent='start'>
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            sx={{
              mx: 2,
              cursor: 'pointer',
              borderBottom:
                activeTab === tab.id
                  ? `4px solid ${theme.palette.text.primary}`
                  : 'none',
              pb: 0.5,
            }}
          >
            <Typography
              variant='body2'
              color={activeTab === tab.id ? 'text.primary' : 'text.secondary'}
              fontWeight={activeTab === tab.id ? 600 : 400}
            >
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Box>
      <Divider />
    </Box>
  );
};

export default TabSection;
